<template compiler="vugel">
    <picture :x="10" :y="10" src="./assets/rotterdam.jpg" />
</template>

<script lang="ts">
export default {};
</script>
